/* ============================================================================
 * /pitchdeck/:deckId — renders a TRACKED deck version.
 *   /pitchdeck            → LATEST (see LATEST_DECK_VERSION)
 *   /pitchdeck/v2026.09   → X   · the co-founder's PDF integrated
 *   /pitchdeck/v2026.09.1 → X+1 · after the per-slide challenge
 *   /pitchdeck/v2026.09.2 → X+2 · big vision (also its own URL, /pitchdeck-big-vision)
 *   /pitchdeck/v1, /v2, /v3, /x, /x1, /x2, /big-vision, /vision → aliases
 * An unknown segment falls back to LATEST so a stale link never 404s.
 * Version registry + stamps: PitchDeckV2Page.tsx (DECK_VERSIONS).
 * ========================================================================== */
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LATEST_DECK_VERSION, PitchDeckV2Page, resolveDeckVersion } from './PitchDeckV2Page';

export const PitchDeckRoute = () => {
  const { deckId } = useParams<{ deckId: string }>();
  const navigate = useNavigate();
  const version = resolveDeckVersion(deckId);

  useEffect(() => {
    if (deckId && !version) navigate('/pitchdeck', { replace: true });
  }, [deckId, version, navigate]);

  return <PitchDeckV2Page version={version ?? LATEST_DECK_VERSION} />;
};
